import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["form", "submitBtn", "wrapperForm", "wrapperThankyou"];

  connect() {
    this.submitOriginalContent = this.submitBtnTarget.innerHTML;
    const openIn = Number(this.data.get("openIn") || 5);
    if (!this._canOpen()) return;
    this._openInTime(openIn);
  };

  close() {
    this.element.close();
    this._hideLoading()
    window.localStorage.setItem("revinate-modal-seen", "true")
  }

  async submit(event) {
    event.preventDefault();
    
    // Check if form is valid (triggers HTML5 validation messages)
    if (!this.formTarget.checkValidity()) {
      this.formTarget.reportValidity();
      return;
    }

    this._showLoading();

    const csrfToken =  document.querySelector("meta[name='csrf-token']").getAttribute('content');

    const url = this.data.get("url");

    const formData = new FormData(this.formTarget);
    this._include_pdp_data(formData)
    const data = Object.fromEntries(formData.entries());
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify(data)
      })

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      this._showThankYou();
    } catch (error) {
      console.error('Error submitting form:', error);
      this._hideLoading();
    }
  }

  _openInTime(timeInSeconds = 0) {
    setTimeout(() => {
      this.element.showModal()
    }, timeInSeconds * 1000);
  }

  _showLoading() {
    this.submitBtnTarget.innerHTML = "Signing up...";
    this.submitBtnTarget.disabled = true;
  }

  _showThankYou() {
    this.wrapperThankyouTarget.removeAttribute("hidden");
    this.wrapperFormTarget.setAttribute("hidden", '');
  }

  _hideLoading() {
    this.submitBtnTarget.innerHTML = this.submitOriginalContent;
    this.submitBtnTarget.disabled = false;
  }

  _canOpen() {
    return window.localStorage.getItem("revinate-modal-seen") !== "true"
  }

  _include_pdp_data(formData) {
    if (window.unitLayerGTM && window.unitLayer) {
      const pdpData = window.unitLayer.ecommerce
      const pdpQuote = window.unitLayerGTM.ecommerce.items[0];
      const pdpQuoteTotal = window.unitLayerGTM.ecommerce.value;

      formData.append("CARTURL", window.location.href)
      formData.append("CARTRESORTNAME", pdpData.house_category)
      formData.append("CARTHOMENAME", pdpData.house_name)
      formData.append("CARTHOMEURL", pdpData.url_of_home)
      formData.append("CARTSKU", pdpData.house_sku)
      formData.append("CARTEMAILIMAGE", pdpData.email_image)
      formData.append("CARTPROPERTYIMAGE", pdpData.image_1)
      formData.append("CARTNUMBEROFBADROOMS", pdpData.number_of_bedrooms)

      formData.append("CARTCHECKINDATE", pdpQuote.checkin_date || null)
      formData.append("CARTCHECKOUTDATE", pdpQuote.checkout_date || null)
      formData.append("CARTNUMBEROFNINGHTS", pdpQuote.quantity)
      formData.append("CARTNUMBEROFGUESTS", pdpQuote.total_guests || 0)
      formData.append("CARTCURRENCY", "USD")
      formData.append("CARTPRICEPERNIGHT", pdpQuote.price || 0)
      formData.append("CARTTOTAL", pdpQuoteTotal || 0)
    }
  }
}
